
import { faWarning } from '@fortawesome/pro-regular-svg-icons'
import {
  Anchor,
  Box,
  Card,
  Flex,
  Loader,
  Switch,
  Text,
  Tooltip,
} from '@mantine/core'
import clsx from 'clsx'

import {
  useQueryGetStoreCustomDomainStatus,
  useQueryGetStoreDetails,
} from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { CollapsibleCard, Icon } from '@flecto/ui'

import { FormSection } from '../FormStoreSettings/FormSection'
import { useFormContext } from '../FormStoreSettings/FormStoreSettings'
import styles from './styles.module.css'

export function CardStoreStatus() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const form = useFormContext()

  const { data: store } = useQueryGetStoreDetails()

  const { data: domainStatus, isLoading } = useQueryGetStoreCustomDomainStatus({
    domain: store?.apex_domain ?? '',
    enabled: Boolean(store?.apex_domain),
  })

  const classesCardStatus = clsx(styles.cardStoreStatus, {
    [styles.cardStoreStatusActive]: form.values.enabled,
  })

  const apexUrl = store?.apex_domain
    ? `https://${store?.apex_domain}`
    : undefined

  const url = `https://${store?.domain}.flecto.store`

  const isApexValid = domainStatus?.configured && !isLoading

  return (
    <FormSection>
      <CollapsibleCard className={classesCardStatus} h={100} mb={50}>
        <CollapsibleCard.Title>
          {t('section_status.title')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          <Box mr='md'>{t('section_status.description')}</Box>
        </CollapsibleCard.Description>
        <CollapsibleCard.RightSection>
          <Switch
            key={form.key('enabled')}
            size='md'
            {...form.getInputProps('enabled', { type: 'checkbox' })}
          />
        </CollapsibleCard.RightSection>
      </CollapsibleCard>
      <Tooltip
        label={t('section_quick_access.description_disabled')}
        disabled={store?.enabled}
        position='bottom'
      >
        <Card w='250' h='100' bg='gray.0' withBorder={false}>
          <Flex align='center' gap='xs' mb='sm'>
            <Text fw={500}>{t('section_quick_access.title')}</Text>
          </Flex>
          <Flex direction='column' gap='xs'>
            {apexUrl && (
              <Tooltip
                label={t('section_quick_access.domain_needs_configuration')}
                disabled={isApexValid}
              >
                <Anchor
                  href={isApexValid ? apexUrl : 'javascript:void(0)'}
                  target='_blank'
                  size='sm'
                  c={!isApexValid ? 'orange' : undefined}
                  style={{
                    cursor: !isApexValid ? 'not-allowed' : 'pointer',
                  }}
                >
                  <Flex align='center' gap='xs'>
                    {apexUrl}
                    {isLoading && <Loader size={10} />}
                    {!domainStatus?.configured && (
                      <Icon
                        icon={faWarning}
                        color='orange'
                        size='xs'
                        display='inline-block'
                      />
                    )}
                  </Flex>
                </Anchor>
              </Tooltip>
            )}
            <Anchor href={url} target='_blank' size='sm'>
              {url}
            </Anchor>
          </Flex>
        </Card>
      </Tooltip>
    </FormSection>
  )
}
